import { Typography } from 'antd';
import { IRestColumnProps } from 'components/rest/Table/TableColumn';
import RestList from 'containers/rest/List';
import React from 'react';
import { Link } from 'react-router-dom';
import { DynamicObjectType, FilterFromUrlResponseType } from 'types/commons';
import { DATA_FIELD_SEARCH } from '../utilts';
import useGetSearchKey from 'hooks/useSearchKeys';
import { useGetFilter } from 'hooks/useSearchParamsObj';

const OrdersList = ({
  selectedData,
  isDetail,
}: {
  selectedData: any;
  isDetail?: boolean;
}) => {
  const { searchParams } = useGetFilter();

  const restInitialFilter: FilterFromUrlResponseType = {
    join: ['order'],
    filters: [
      {
        condition: 'and',
        key: 'id',
        operator: 'in',
        value: selectedData,
      },
    ],
  };
  const { searchKeys } = useGetSearchKey(DATA_FIELD_SEARCH);

  const columns: IRestColumnProps[] = [
    {
      name: 'id',
      title: 'TO ID',
      render: (d: string, record: DynamicObjectType) => (
        <Link to={`/transfer-orders/${record?.id}/show`}>
          <Typography.Paragraph
            ellipsis={{ rows: 1 }}
            style={{ width: 150, color: '#AB2328' }}
          >
            {record?.toId || d}
          </Typography.Paragraph>
        </Link>
      ),
      isDefault: true,
    },
    {
      name: 'orderId',
      title: 'Related order ID',
      isDefault: true,
      render: (d: string, record: DynamicObjectType) => (
        <Link to={`/order-management/${record?.orderId}/show`}>
          <Typography.Paragraph
            ellipsis={{ rows: 1 }}
            style={{ width: 150, color: '#AB2328' }}
          >
            {record?.order?.orderNumber}
          </Typography.Paragraph>
        </Link>
      ),
    },
    {
      name: 'fromWarehouse',
      title: 'From warehouse',
      render: (d: DynamicObjectType) => (
        <div style={{ minWidth: 120 }}>{d?.name}</div>
      ),
      isDefault: true,
    },
    {
      name: 'toWarehouse',
      title: 'To warehouse',
      render: (d: DynamicObjectType) => (
        <div style={{ minWidth: 120 }}>{d?.name}</div>
      ),
      isDefault: true,
    },
    {
      name: 'itemsCount',
      title: 'Number of items',
      isDefault: true,
    },
    isDetail && {
      name: 'description',
      title: 'Note',
      isDefault: true,
    },
  ];

  return (
    <RestList
      initialFilter={restInitialFilter}
      columns={columns?.filter((i) => !!i)}
      model="transferOrders"
      hasOnlyFilter
      hasShowFilter={false}
      rowSelectionActions={!isDetail && <></>}
      hasImport={false}
      hasExport={false}
      hasCustomLayout
      initSelectedRowKeys={selectedData}
      hasSearch
      searchKeys={searchKeys}
      dataFieldSearch={DATA_FIELD_SEARCH}
      searchOperator={searchParams.get('fieldSearch') === 'id' ? 'eq' : 'contL'}
      placeholderInputSearch="Search Related Order ID, Transfer ID, TO number, SKU..."
    />
  );
};

export default OrdersList;
